module.exports = __webpack_public_path__ + "img/24.9044159f.gif";